// src/components/modules/table/ExportData.js
import * as XLSX from 'xlsx'
import { CSVLink } from 'react-csv'
import dayjs from 'dayjs'

export const ExportXLS = ({
  data,
  title,
  currentBusiness,
  rut,
  // tus props antiguas
  month,
  year,
  // nuevas props opcionales
  from,
  to
}) => {
  const exportToXLS = () => {
    // 1) Creamos la hoja
    const ws = XLSX.utils.json_to_sheet([])

    // 2) Decidir qué header usar
    let headerLine
    if (from && to) {
      const start = dayjs(from)
      const end = dayjs(to)
      const monthNames = [
        'ENERO',
        'FEBRERO',
        'MARZO',
        'ABRIL',
        'MAYO',
        'JUNIO',
        'JULIO',
        'AGOSTO',
        'SEPTIEMBRE',
        'OCTUBRE',
        'NOVIEMBRE',
        'DICIEMBRE'
      ]
      const startMonth = monthNames[start.month()]
      const endMonth = monthNames[end.month()]
      const y = start.year()
      headerLine = `EJERCICIO DESDE ${startMonth} A ${endMonth} DE ${y}`
    } else {
      // tu lógica clásica
      headerLine = `EJERCICIO DESDE ${month} A ${month} DE ${year}`
    }

    // 3) Insertar cabeceras AOA
    XLSX.utils.sheet_add_aoa(
      ws,
      [['Resumen de movimientos'], [currentBusiness], [rut], [], [title], [headerLine]],
      { origin: 'A1' }
    )

    // 4) Estilos título/subtítulo
    ws['A5'].s = ws['A6'].s = {
      alignment: { horizontal: 'center' },
      font: { bold: true, sz: 24 }
    }

    // 5) Insertar datos JSON
    XLSX.utils.sheet_add_json(ws, data, { origin: 'A8', skipHeader: false })

    // 6) Estilizar fila de headers JSON (fila 8)
    const headerRowIndex = 7
    const keys = Object.keys(data[0] || {})
    keys.forEach((_, col) => {
      const cell = XLSX.utils.encode_cell({ r: headerRowIndex, c: col })
      if (ws[cell]) {
        ws[cell].s = {
          font: { bold: true },
          border: { bottom: { style: 'medium', color: { rgb: '000000' } } }
        }
      }
    })

    // 7) Pie de firma
    const lastDataRow = data.length + 7
    const footerStart = lastDataRow + 2
    XLSX.utils.sheet_add_aoa(
      ws,
      [
        [''],
        [
          `Declaro(mos) dejando constancia que el presente ${title} ha sido confeccionado correctamente. Para constancia, firmamos:`
        ],
        ['', '__________________', '', '__________________'],
        ['', 'Contador', '', 'Representante Legal']
      ],
      { origin: `B${footerStart}` }
    )

    // 8) Ajustes de columnas y grid
    ws['!cols'] = keys.map(() => ({ wch: 20 }))
    ws['!gridlines'] = false

    // 9) Libro y descarga
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
    const fileLabel =
      from && to ? `_${from.replace(/-/g, '')}-${to.replace(/-/g, '')}` : `_${month}_${year}`
    XLSX.writeFile(wb, `${title}_${currentBusiness}_${rut}${fileLabel}.xlsx`)
  }

  return (
    <button
      className='w-10 h-10 text-green-700 font-bold cursor-pointer rounded-full shadow bg-white'
      onClick={exportToXLS}
    >
      XLS
    </button>
  )
}

// CSV puede seguir igual, o adaptarse si necesitas nombre con from/to
export const ExportCSV = ({ data, title, currentBusiness, rut, month, year, from, to }) => {
  const filename =
    from && to
      ? `movimientos_${title}_${currentBusiness}_${rut}_${from}_${to}.csv`
      : `movimientos_${title}_${currentBusiness}_${rut}_${month}_${year}.csv`

  return (
    <CSVLink data={data} filename={filename}>
      <button className='w-10 h-10 text-blue-700 font-bold cursor-pointer rounded-full shadow bg-white'>
        CSV
      </button>
    </CSVLink>
  )
}
